module.exports = __webpack_public_path__ + "static/media/02n.144d9a47.svg";